/* eslint-disable */
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ReferenceLine,
  ResponsiveContainer
} from 'recharts';
import { scaleSymlog } from 'd3-scale';
import CustomTooltip from './CustomTooltip';
import GraphNoData from '../../assets/images/graphNoData.png';
import currencyFormat from 'utils/currencyFormat';
import { formatPaymentMode } from 'pages/DashBoardPage/const';

function PositiveNegativeBarChartGraph({ commissionData }) {
  return (
    <ResponsiveContainer width="100%" height={550}>
      {commissionData?.length > 0 ? (
        <BarChart
          width={500}
          height={400}
          margin={{ top: 20, right: 20, left: 0, bottom: 5 }}
          layout="vertical"
          data={commissionData}
        >
          <CartesianGrid vertical={true} horizontal={false} strokeDasharray="3 3" />
          <YAxis
            dataKey="mode"
            type="category"
            tickFormatter={formatPaymentMode}
            tick={{ fill: 'black', fontSize: 14, dy: 1 }}
            label={{
              value: 'Payment Mode',
              angle: -90,
              position: 'insideLeft',
              offset: 17,
              fontSize: 14,
              fill: 'black'
            }}
            stroke="black"
            axisLine={{ stroke: 'black' }}
            tickLine={{ stroke: 'black' }}
            interval={0}
            width={120}
          />
          <Tooltip cursor={false} content={<CustomTooltip />} />
          <Legend
            content={
              <ul className="custom-legend">
                <li style={{ marginRight: 20, display: 'flex', alignItems: 'center' }}>
                  <div className="legend-dot positive" />
                  <span>Commission Earned</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'center' }}>
                  <div className="legend-dot negative" />
                  <span>Negative Commission</span>
                </li>
              </ul>
            }
          />
          <XAxis
            type="number"
            scale={scaleSymlog()}
            label={{
              value: 'Commission Earned (₹)',
              position: 'insideBottom',
              offset: -20,
              fontSize: 14,
              fill: 'black'
            }}
            stroke="black"
            tick={{ fill: 'black', fontSize: 13 }}
            axisLine={{ stroke: 'black' }}
            tickLine={{ stroke: 'black' }}
            tickFormatter={(value) => currencyFormat(value, true, true)}
          />
          <ReferenceLine x={0} stroke="#000" />

          <Bar
            dataKey="total"
            barSize={40}
            shape={({ x, y, width, height, payload }) => {
              const color = payload.total < 0 ? '#DB0000' : '#009D19';
              const isNegative = width < 0;
              return (
                <rect
                  x={isNegative ? x + width : x}
                  y={y}
                  width={Math.abs(width)}
                  height={height}
                  fill={color}
                />
              );
            }}
          />
        </BarChart>
      ) : (
        <div className="graph-no-data">
          <img src={GraphNoData} width="320px" height="170px" alt="Seems like no data" />
        </div>
      )}
    </ResponsiveContainer>
  );
}

PositiveNegativeBarChartGraph.propTypes = {
  commissionData: PropTypes.instanceOf(Array).isRequired
};

export default PositiveNegativeBarChartGraph;
